import React from 'react';

import palette from '@/public/images/theme_features/range.svg';

import NextImage from '../UI/nextImage/NextImage';
import { Title } from '../UI/title/Title';

import styles from './Palette.module.scss';

const Palette = () => {
    return (
        <div className={styles.palette}>
            <div className={styles.palette__info}>
                <Title text="Different Colour Schemes" size="xs" className={styles.heading} />
                <p className={`excerpt body-md ${styles.excerpt}`}>
                    Customize your site&apos;s aesthetic with a variety of color schemes to match
                    your brand or needs.
                </p>
            </div>
            <div className={styles.palette__wrapper}>
                <NextImage
                    src={palette.src}
                    alt="pipe"
                    fill
                    sizes="(max-width: 500px) 75.2vw, (max-width: 1024px) 379px, (max-width: 1300px) 30vw, 379px"
                />
            </div>
        </div>
    );
};

export default Palette;
